import React from "react";
import { Box, Typography, TypographyProps } from "@material-ui/core";

interface FormHeadingProps {
  typographyProps?: Partial<TypographyProps>;
}

export const FormSectionHeading: React.FC<FormHeadingProps> = ({
  typographyProps,
  children,
}) => {
  return (
    <Box clone color="#000000">
      <Typography variant="overline" {...typographyProps}>
        {children}
      </Typography>
    </Box>
  );
};
